import { MultiLangString } from './lingua_sistema';
import { HmModelRest } from './abstract_model';

export class Esame extends HmModelRest {
    static readonly rest_path = 'esami';

    id: number;
    categoria_esame: number | CategoriaEsame;
    nome: MultiLangString;
    dettaglio: MultiLangString;
    informazioni: MultiLangString;
    da_prenotare: boolean;
    prenotabile_app: boolean;
    branca: string;
    cod_prestazione: string;
    desc_cup: string;
    desc_nomenclatore: string;
    cod_nomenclatore: string;
    //servizi_prenotazione: number[]; // esami_servizi_prenotazioni many to many
}

export class ServizioPrenotazioni extends HmModelRest {
    static readonly rest_path = 'servizi_prenotazioni';
    id: number;
    nome: string;
}

export class CategoriaEsame extends HmModelRest {
    static readonly rest_path = 'categorie_esami';
    id: number;
    nome: MultiLangString;
    icona: string;
}

